export enum CategoryIcons {
  animals = 'animals',
  audio = 'audio',
  childhood = 'childhood',
  clothing = 'clothing',
  culture = 'culture',
  decor = 'decor',
  electrical = 'electrical',
  games = 'games',
  halloween1 = 'halloween1',
  halloween2 = 'halloween2',
  home = 'home',
  hygiene = 'hygiene',
  kitchen = 'kitchen',
  lighting = 'lighting',
  other = 'other',
  scene = 'scene',
  security = 'security',
  signaletic = 'signaletic',
  sports = 'sports',
  tech = 'tech',
  technical = 'technical',
  telecom = 'telecom',
  tents = 'tents',
  ticketing = 'ticketing',
  tools = 'tools',
  transactions = 'transactions',
  transportation = 'transportation',
  video = 'video',
  wellness = 'wellness',
  plants = 'plants',
  seeds = 'seeds',
  tools_st = 'tools_st',
  machinery_st = 'machinery_st',
  hardware_st = 'hardware_st',
  material_st = 'material_st',
  clothing_st = 'clothing_st',
  space_st = 'space_st',
  input_st = 'input_st',
}
